import axios from "axios";

const chargePointHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/ChargePoint/`,
  headers: {
    "Content-Type": "application/json",
  },
});

const transactionClientHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/TransactionClient/`,
  headers: {
    "Content-Type": "application/json",
  },
});

const transactionPaymentHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/TransactionPaymentToken/`,
  headers: {
    "Content-Type": "application/json",
  },
});

const companyHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/Company/`,
  headers: {
    "Content-Type": "application/json",
  },
});

export { chargePointHttpClient, transactionClientHttpClient, transactionPaymentHttpClient, companyHttpClient };
